
import axios from "axios";

export const getTokenBalance = async function (address, callback) {

    const params = new URLSearchParams();
    params.append('module', 'account');
    params.append('action', 'tokenbalance');
    params.append('contractaddress', process.env.REACT_APP_POLYGON_TOKEN_CONTRACT_ADDRESS);
    params.append('address', address);
    params.append('tag', 'latest');
    params.append('apikey', process.env.REACT_APP_POLYGONSCAN_KEY);
 
    const url = 'https://api.polygonscan.com/api';

    await axios.post(url, params)
        .then((response) => {
            // console.log(response); 
            return callback(null, response);

        }).catch((err) => {
            // console.log(err);
            return callback(err, null);
        }).finally(() => {

        });
};

export const getEtherBalance = async function (address, callback) {

    const params = new URLSearchParams();
    params.append('module', 'account');
    params.append('action', 'balance');
    params.append('address', address);
    params.append('tag', 'latest');
    params.append('apikey', process.env.REACT_APP_POLYGONSCAN_KEY);
 
    const url = 'https://api.polygonscan.com/api';

    await axios.post(url, params)
        .then((response) => {
            // console.log(response); 
            return callback(null, response);

        }).catch((err) => {
            // console.log(err);
            return callback(err, null);
        }).finally(() => {

        });
};